import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import { CREATE_EVENT, DELETE_EVENT, UPDATE_EVENT } from "./mutations";
import {
  CreateEvent,
  CreateEventVariables,
  UpdateEvent,
  UpdateEventVariables,
  DeleteEvent,
  DeleteEventVariables,
} from "./__generated__/mutations";
import {
  GetEvents,
  GetEventsVariables,
  GetEvent,
  GetEventVariables,
  GetEventOccurrences,
  GetEventOccurrencesVariables,
  GetEventOccurrence,
  GetEventOccurrenceVariables,
} from "./__generated__/queries";
import {
  GET_EVENTS,
  GET_EVENT,
  GET_EVENT_OCCURRENCES,
  GET_EVENT_OCCURRENCE,
} from "./queries";

export const useEventCreateMutation = makeMutationHook<
  CreateEvent,
  CreateEventVariables
>(CREATE_EVENT);

export const useEventUpdateMutation = makeMutationHook<
  UpdateEvent,
  UpdateEventVariables
>(UPDATE_EVENT);

export const useEventDeleteMutation = makeMutationHook<
  DeleteEvent,
  DeleteEventVariables
>(DELETE_EVENT);

export const useEventListQuery = makeQueryHook<GetEvents, GetEventsVariables>(
  GET_EVENTS
);

export const useEventDetailsQuery = makeQueryHook<GetEvent, GetEventVariables>(
  GET_EVENT
);

export const useEventOccurrencesQuery = makeQueryHook<
  GetEventOccurrences,
  GetEventOccurrencesVariables
>(GET_EVENT_OCCURRENCES);

export const useEventOccurrenceQuery = makeQueryHook<
  GetEventOccurrence,
  GetEventOccurrenceVariables
>(GET_EVENT_OCCURRENCE);
